<template>
  <div>
          <div class="nutritional">
              <div>
                  运动方案:
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">运动目的</div>
              </div>
              <div class="card" style="flex-direction: column">
                <div v-for="(item, index) in schemeExercise.specialNotes" :key="index">
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h2"></div>
                <div class="dt">运动频率</div>
              </div>
              <div class="card">
                {{ schemeExercise.schemeExerciseNew.sportsFrequency ? schemeExercise.schemeExerciseNew.sportsFrequency : '' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h3"></div>
                <div class="dt">运动强度</div>
              </div>
              <div class="card">
                有氧运动：{{ schemeExercise.schemeExerciseNew.aerobicExercise ? schemeExercise.schemeExerciseNew.aerobicExercise : '' }}
                <br />
                力量运动：{{ schemeExercise.schemeExerciseNew.strengthTrain ? schemeExercise.schemeExerciseNew.strengthTrain : '' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h4"></div>
                <div class="dt">运动时间</div>
              </div>
              <div class="card">
                总时长：{{ schemeExercise.schemeExerciseNew.totalDuration ? schemeExercise.schemeExerciseNew.totalDuration : '' }}
                <br />
                结构包括：{{ schemeExercise.schemeExerciseNew.structure ? schemeExercise.schemeExerciseNew.structure : '' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h5"></div>
                <div class="dt">每周每天运动类型推荐</div>
              </div>
              <div class="card">
                有氧类：{{ schemeExercise.schemeExerciseNew.homeAerobic ? schemeExercise.schemeExerciseNew.homeAerobic : '' }}
                <br />
                力量类：{{ schemeExercise.schemeExerciseNew.homePower ? schemeExercise.schemeExerciseNew.homePower : '' }}
                <br />
                柔韧类：{{ schemeExercise.schemeExerciseNew.homeFlexible ? schemeExercise.schemeExerciseNew.homeFlexible : '' }}
                <br />
                机构运动项目：{{ schemeExercise.schemeExerciseNew.mechanismMotion ? schemeExercise.schemeExerciseNew.mechanismMotion : '' }}
              </div>
            </div>
            <div class="nutritional">
            <div>
                运动计划:
            </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">适应期 (第1-4周)</div>
              </div>
              <div class="card">
                运动时间：{{ schemeExercise.schemeExerciseNew.adaptTime ? schemeExercise.schemeExerciseNew.adaptTime : '' }}
                <br />
                运动频率：{{ schemeExercise.schemeExerciseNew.adaptFrequency ? schemeExercise.schemeExerciseNew.adaptFrequency : '' }}
                <br />
                运动强度：{{ schemeExercise.schemeExerciseNew.adaptIntensity ? schemeExercise.schemeExerciseNew.adaptIntensity : '' }}
                <br />
                目标能耗/次：{{ schemeExercise.schemeExerciseNew.adaptEnergyConsumption ? schemeExercise.schemeExerciseNew.adaptEnergyConsumption : '' }}
                <br />
                具体目标：{{ schemeExercise.schemeExerciseNew.adaptTarget ? schemeExercise.schemeExerciseNew.adaptTarget : '' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h2"></div>
                <div class="dt">强化期 (第5-12周)</div>
              </div>
              <div class="card">
                运动时间：{{ schemeExercise.schemeExerciseNew.reinforcementTime ? schemeExercise.schemeExerciseNew.reinforcementTime : '' }}
                <br />
                运动频率：{{ schemeExercise.schemeExerciseNew.reinforcementFrequency ? schemeExercise.schemeExerciseNew.reinforcementFrequency : '' }}
                <br />
                运动强度：{{ schemeExercise.schemeExerciseNew.reinforcementIntensity ? schemeExercise.schemeExerciseNew.reinforcementIntensity : '' }}
                <br />
                目标能耗/次：{{ schemeExercise.schemeExerciseNew.reinforcementEnergyConsumption ? schemeExercise.schemeExerciseNew.reinforcementEnergyConsumption : '' }}
                <br />
                具体目标：{{ schemeExercise.schemeExerciseNew.reinforcementTarget ? schemeExercise.schemeExerciseNew.reinforcementTarget : '' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h3"></div>
                <div class="dt">稳定期 (第13周及以后)</div>
              </div>
              <div class="card">
                运动时间：{{ schemeExercise.schemeExerciseNew.stableTime ? schemeExercise.schemeExerciseNew.stableTime : '' }}
                <br />
                运动频率：{{ schemeExercise.schemeExerciseNew.stableFrequency ? schemeExercise.schemeExerciseNew.stableFrequency : '' }}
                <br />
                运动强度：{{ schemeExercise.schemeExerciseNew.stableIntensity ? schemeExercise.schemeExerciseNew.stableIntensity : '' }}
                <br />
                目标能耗/次：{{ schemeExercise.schemeExerciseNew.stableEnergyConsumption ? schemeExercise.schemeExerciseNew.stableEnergyConsumption : '' }}
                <br />
                具体目标：{{ schemeExercise.schemeExerciseNew.stableTarget ? schemeExercise.schemeExerciseNew.stableTarget : '' }}
              </div>
            </div>
  </div>
</template>

<script>
import { getMotion, getBodyDate, getUserJkDetail, getExerciseSchemeNew, getExercisePrescription } from '@/api/health/manage'

export default {
  name: 'SportsPlan',
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      form: {},
      schemeExercise: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      data: [],
      showDialog: false, // 控制弹框显示
      dialogVisible: false,
      formData: {
        // name: "",
        // gender: "女",
        // age: 43,
        // phone: "153****8212",
        // idNumber: "320111198202*****",
        medicalHistory: '无疾病',
        medication: '',

        height: 162,
        weight: 86.9,
        activityLevel: 0,
        ydfxdj: 0,
        xfgn: 0,
        jrll: 0,
        tcf: 0,
        jdxt: 1,
        tzxz: 1,
        jdxy: 1,
        jz: 1,
        zjxfnl: 1,
        zjjrll: 1,
        zjstrrx: 1,
        jgydxm: 3,
        exercisePurposes: ['降低血压', '调整血脂', '降低血糖', '减重', '增加心肺活力'],
        institutionExercises: [
          {
            name: '二头/三头肌训练',
            level: '1档',
            sets: '4组',
            reps: '21个/组'
          },
          {
            name: '水瓶直筒侧平举',
            level: '2档',
            sets: '4组',
            reps: '24个/组'
          }
        ],
        notes: ['饭前饭后1小时内尽量不要运动', '锻炼后不应立即入浴、大汗淋漓时通低温，会使皮肤表层收缩，严重时引起闭汗症或静脉曲张'],
        doctor: '',
        followUpDate: new Date().toLocaleDateString()
      },
      pdfOptions: {
        margin: 10,
        filename: '运动处方.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait'
        }
      },
      weekTap: 1,
      chuFshow: 1,
      exerciseInfo: [],
      exercisePrescription: {},
      homeMotion: ['', '', '', '', '', '', '', '', ''],
      group: ['', '', '', '', '', '', '', '', ''],
      num: ['', '', '', '', '', '', '', '', ''],
      mechanismMotion: ['', '', '', '', '', '', '', '', ''],
      adapt: {},
      reinforcement: {},
      stable: {},
      specialNotes: ['', '', '', '', '', '', '', '', ''],
      sportsPurposes: []
    }
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId
      this.formData.followUpDate = new Date(new Date().setMonth(new Date().getMonth() + 3)).toLocaleDateString()

      getMotion(wxUserId).then(res => {
        this.data = res.data
        this.pdfOptions.filename = '运动处方_' + res.data[0].name
        this.formData.name = res.data[0].name
        this.formData.age = res.data[0].age
        if (res.data[0].sex === 2) this.formData.gender = '女'
        else if (res.data[0].sex === 1) this.formData.gender = '男'
        this.formData.phone = res.data[0].mobile
        this.formData.idNumber = res.data[0].id_card
        this.formData.height = res.data[0].height
        this.formData.weight = res.data[0].weight
      })

      getBodyDate(wxUserId).then(res => {
        this.body = res.data.medicalExaminationReport
      })

      getUserJkDetail(wxUserId).then(res => {
        this.info = res.data.userJk
        if (this.info.sex === 1) this.info.gender = '男'
        else if (this.info.sex === 2) this.info.gender = '女'
      })

      getExerciseSchemeNew(wxUserId).then(res => {
        this.schemeExercise = res.data
        const exerciseInfo = [
          { name: '运动类型', value: this.schemeExercise.schemeExerciseNew.sevenExerciseType },
          { name: '推荐项目', value: this.schemeExercise.schemeExerciseNew.sevenExerciseRecommend }
        ]
        this.exerciseInfo = exerciseInfo
      })

      getExercisePrescription(wxUserId).then(res => {
        console.log('getExercisePrescription', res.data)
        const formData = this.formData
        const exercisePrescription = res.data
        formData.bs = exercisePrescription.bs || ''
        formData.bp = exercisePrescription.bp || ''
        formData.hr = exercisePrescription.hr || ''
        formData.cho = exercisePrescription.cho || ''
        formData.fat_rate = exercisePrescription.fat_rate || ''
        formData.fat = exercisePrescription.fat || ''
        formData.slm = exercisePrescription.slm || ''
        formData.vfa = exercisePrescription.vfa || ''
        for (let i = 0; i < exercisePrescription.homeMotion.length; i++) this.homeMotion[i] = exercisePrescription.homeMotion[i]
        for (let i = 0; i < exercisePrescription.homeMotion.length; i++) this.mechanismMotion[i] = exercisePrescription.mechanismMotion[i]
        this.adapt = exercisePrescription.adapt || ''
        this.reinforcement = exercisePrescription.reinforcement || ''
        this.stable = exercisePrescription.stable || ''
        this.specialNotes = exercisePrescription.specialNotes || ''
        this.sportsPurposes = exercisePrescription.sportsPurposes || ''
        formData.ydfxdj = exercisePrescription.riskLevel
        console.log(res.data)
        console.log("riskLevel: ", exercisePrescription.riskLevel)
        this.formData = formData
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/* 重置所有继承属性 */
.style-isolation {
  all: initial;
}

/* 重置内部所有元素 */
.style-isolation * {
  all: unset;
}
template {
  all: initial;
}
.card {
  display: flex;
}
.right {
  width: 80%;
  padding: 10px 20px;
}
.chuF {
  width: 90%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2%;
  .title {
    display: flex;
    div {
      width: 12%;
      height: 40px;
      line-height: 40px;
      border: 1px solid #666666;
      text-align: center;
      color: #666666;
      border-radius: 24px;
      margin-right: 2%;
    }
    .active {
      background-color: #409eff;
      color: #fff;
      border: none;
    }
  }
  .content {
    width: 100%;
    .name {
      height: 45px;
      padding: 10px 0;
      display: flex;
      margin-top: 10px;
      .icon {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin: 5px 10px 0 0;
      }
      .h1 {
        background-color: #409eff;
      }
      .h2 {
        background-color: #fe62e7;
      }
      .h3 {
        background-color: #ff9037;
      }
      .h4 {
        background-color: #43d87f;
      }
      .h5 {
        background-color: #bb68fc;
      }
      .dt {
        color: #0f1021;
        font-size: 16px;
      }
    }
    .card {
      border-left: 1px solid #e6e6e6;
      padding: 0 20px;
      margin-left: 5px;
      color: #666666;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .nutritional{
      padding-top: 30px;
      display: flex;
      div{
        width: 90%;
        // height: 50px;
        line-height: 30px;
        font-size: 20px;
        color: #409EFF;
      }
    }
}
.week {
  width: 90%;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 16px;
  display: flex;
  .side {
    font-size: 25px;
    background-color: red;
    width: 5%;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    writing-mode: vertical-lr; /* 从左到右的垂直文本 */
    letter-spacing: 8px;
    padding-left: 1%;
    text-align: center;
    background-color: #409eff;
    color: #fff;
  }
  .content {
    width: 95%;
    padding: 2% 4%;
    .title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      div {
        width: 5%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #aaa6c8;
        border-radius: 12px;
      }
      .active {
        background-color: #409eff;
        color: #fff;
      }
    }
    .tent {
      display: flex;
      justify-content: space-between;
      margin: 20px 10% 0 10%;
      .exercise {
        width: 40%;
        padding: 16px 2%;
        border: 1px solid #aaa6c8;
        border-radius: 12px;
        background-color: #f0f8ff;
        color: #666666;
        font-size: 14px;
        line-height: 24px;
        div:first-child {
          width: 100%;
          margin-bottom: 5px;
          font-size: 16px;
          font-weight: 600;
        }
        text-align: center;
        min-height: 150px;
      }
    }
  }
}
.plan input {
  text-align: left;
}
</style>
